import React from 'react';
import { useReduxAction } from '@engage/redux/hooks';
import { flushCurrentBatches } from '@engage/video/bufferMetrics';
import { MAXIMUM_DELAY_TIME } from '@members/pg-video/sagas/analytics';
import { bufferingMetricsV2 } from '@members/pg-video/sagas/sagaActions';
import { useStartedClientSession } from './useStartedClientSession';
import useTrackFirstFreemiumSession from './useTrackFirstFreemiumSession';

export const BootupEvents: React.FC<React.PropsWithChildren<unknown>> = () => {
  const flushBatches = useReduxAction(flushCurrentBatches);
  const bufferMetrics = useReduxAction(bufferingMetricsV2);

  React.useEffect(() => {
    // attempt to send any old persisted metrics
    // set delay time to maximum so batches get cleared
    // regardless of success or failure
    flushBatches();
    bufferMetrics(true, MAXIMUM_DELAY_TIME);
  }, []);

  useTrackFirstFreemiumSession();
  useStartedClientSession();
  return null;
};
